
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ChatMessageResponseAllOfOnezeroMediaLinksItemLinkType = typeof ChatMessageResponseAllOfOnezeroMediaLinksItemLinkType[keyof typeof ChatMessageResponseAllOfOnezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageResponseAllOfOnezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
